import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlotItemsListComponent } from './plot-items-list/plot-items-list.component';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    PlotItemsListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class PlotItemsModule { }
